import './i18n'; // MUSS vor App stehen: initialisiert den Katalog synchron beim Import
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initI18n } from './i18n';
import { LanguageProvider } from './contexts/LanguageContext';

// Build-Kennung (vom Deploy-Skript gesetzt) – im Bundle referenziert, damit jeder
// Deploy einen neuen Dateinamen bekommt; hilft beim Support ("welcher Stand läuft?")
(window as any).__DC_BUILD_ID = process.env.REACT_APP_BUILD_ID ?? 'dev';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
// Sprache + Übersetzungen VOR dem ersten Render (de eingebaut, aktuelle Sprache als eigener Chunk,
// Server max. 1,5 s). Die App wird erst DANACH importiert, damit Label-Konstanten auf Modulebene
// schon in der richtigen Sprache ausgewertet werden (31.10.2026, weitere Sprachen).
initI18n()
  .catch(() => undefined)
  .then(() => import('./App'))
  .then(({ default: App }) => {
    root.render(
      <React.StrictMode>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </React.StrictMode>
    );
  });

// Launch-Animation (#dc-splash aus public/index.html) ausblenden, sobald die
// App gemountet ist — mit Mindestanzeigedauer, damit die Animation auch bei
// schnellem Laden sichtbar bleibt. Wird pro Browser-Session nur beim ersten
// Aufruf gezeigt (dc-skip-splash setzt das Inline-Script in index.html).
const splash = document.getElementById('dc-splash');
if (splash) {
  if (document.documentElement.classList.contains('dc-skip-splash')) {
    splash.remove();
  } else {
    const MIN_SHOW_MS = 1100;
    const start: number = (window as any).__dcSplashStart ?? Date.now();
    const remaining = Math.max(0, MIN_SHOW_MS - (Date.now() - start));
    window.setTimeout(() => {
      splash.classList.add('dc-splash-hide');
      window.setTimeout(() => splash.remove(), 500);
    }, remaining);
  }
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
